export default __webpack_public_path__ + "static/media/bg_image.f6f09ed0.png";